import { gql } from '@apollo/client';

export interface HardwareConfigHistoryEntry {
  id: string;
  timestamp: string;
  responsibleId: string;
  responsibleDisplayName: string;
  actionType: string;
  s3Object: string;
}

export interface GetHardwareConfigHistoryData {
  device: {
    profile: {
      hardwareConfigHistory: {
        entries: HardwareConfigHistoryEntry[];
        nextCursor: string | null;
      };
    };
  };
}

export interface GetHardwareConfigHistoryVars {
  deviceId: string;
}

export const GET_HARDWARE_CONFIG_HISTORY = gql`
  query GetHardwareConfigHistory($deviceId: ID!) {
    device(input: { id: $deviceId }) {
      profile {
        hardwareConfigHistory {
          entries {
            id
            timestamp
            responsibleId
            responsibleDisplayName
            actionType
            s3Object
          }
          nextCursor
        }
      }
    }
  }
`;
